export default __webpack_public_path__ + "static/media/audio_21_policia_silbato.2898301d.mp3";